// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

interface BannerVendiProps {
  agencyName: string;
}

const BannerVendi: React.FC<BannerVendiProps> = ({ agencyName }) => {
  const { t } = useTranslation();

  const buttonText = t('homePage.sellBanner.cta');

  return (
    <section
      id="bannerVendi"
      className="space-ptb bg-holder bg-overlay-black-20"
      style={{
        backgroundImage: 'url(/assets/images/bg-bannerVendi.jpg)',
      }}
    >
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="section-title">
              <h2 className="text-white">
                {t('homePage.sellBanner.textWhite')} {agencyName}
              </h2>
            </div>
            <Link className="btn btn-primary mb-2 mb-sm-0" to="/vendi" title={buttonText}>
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerVendi;